<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  @use "../../../../../assets/css/_mixins.scss" as *;
  .checkbox {
    align-items: center;
    display: flex;
    font-size: 0.875rem;
    gap: 0.5rem;

    label {
      align-items: center;
      color: black;
      cursor: pointer;
      display: flex;
      user-select: none;
    }

    input[type="checkbox"] {
      appearance: none;
      margin: 0;

      &:not(:disabled):hover {
        &::before {
          content: "\f00c";
          font-size: 85%;
          font-family: "Font Awesome 6 Pro";
          font-weight: bolder;
        }
      }

      &:not(:disabled)::before {
        align-items: center;
        background-color: white;
        border: 0;
        border-radius: 0.25rem;
        border: 2px solid $text-gray;
        content: "";
        cursor: pointer;
        display: flex;
        justify-content: center;
        @include size(1.25rem);
      }

      &:checked {
        &::before {
          background-color: $primary-color;
          border-color: $primary-color;
          color: white;
          content: "\f00c";
          font-size: 85%;
          font-family: "Font Awesome 6 Pro";
          font-weight: bolder;
        }
      }
    }
  }
</style>

<script>
  export let checked = false;
  export let labelText = "";
  export let inactive = false;
  export let callback = () => {};

  const handleCheckboxChange = (event) => {
    if (inactive) return;
    callback(event.target.checked);
  };

  const randomId = Math.random().toString(36).slice(7);
</script>

<div class="checkbox">
  <input
    type="checkbox"
    id={randomId}
    on:change={handleCheckboxChange}
    bind:checked
    disabled={inactive}
  />
  {#if labelText}
    <label for={randomId}>{labelText}</label>
  {/if}
</div>
